import { AsyncPipe, NgClass, NgTemplateOutlet } from '@angular/common'
import {
  ChangeDetectionStrategy,
  Component,
  TemplateRef,
  Type,
} from '@angular/core'
import { ReactiveFormsModule } from '@angular/forms'
import {
  FieldType,
  FieldTypeConfig,
  FormlyFieldConfig,
  FormlyModule,
} from '@ngx-formly/core'
import { FormlySelectModule } from '@ngx-formly/core/select'
import { TranslatePipe } from '@ngx-translate/core'
import { SvgIconComponent } from 'angular-svg-icon'
import {
  NzOptionComponent,
  NzOptionGroupComponent,
  NzSelectComponent,
  NzSelectModeType,
  NzSelectSizeType,
} from 'ng-zorro-antd/select'
import { Observable } from 'rxjs'

import {
  FormlySelectOption,
  FormlySelectOptionsPipe,
} from '../../../../pipes/select-options.pipe'
import { FormlyFieldProps } from '../common.types'

export interface CustomOptionTemplateContext<T> {
  item: FormlySelectOption<T>
  field: FieldTypeConfig<FormlySelectFieldProps<T>>
}

export interface FormlySelectFieldProps<T = unknown> extends FormlyFieldProps {
  mode?: NzSelectModeType
  isLoading?: boolean
  size?: NzSelectSizeType
  allowClear?: boolean
  hideEmpty?: boolean
  dropdownMatchSelectWidth?: boolean
  maxTagCount?: number
  maxMultipleCount?: number
  options?: FormlySelectOption<T>[] | Observable<FormlySelectOption[]>

  optionItemOverCallback?: (
    field: FieldTypeConfig<FormlySelectFieldProps<T>>,
    item: FormlySelectOption<T>
  ) => void
  openChange?: (field: FieldTypeConfig<FormlySelectFieldProps<T>>) => void
  optionItemTemplate?: TemplateRef<CustomOptionTemplateContext<T>>
}

export interface FormlySelectFieldConfig<T = unknown>
  extends FormlyFieldConfig<FormlySelectFieldProps<T>> {
  type: '#select' | 'select' | Type<SelectFieldTypeComponent<T>>
}

@Component({
  selector: 'app-select-field-type',
  standalone: true,
  imports: [
    NzSelectComponent,
    ReactiveFormsModule,
    FormlyModule,
    FormlySelectModule,
    SvgIconComponent,
    AsyncPipe,
    TranslatePipe,
    FormlySelectOptionsPipe,
    NgClass,
    NzOptionComponent,
    NzOptionGroupComponent,
    NgTemplateOutlet,
  ],
  templateUrl: './select-field-type.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SelectFieldTypeComponent<T = unknown> extends FieldType<
  FieldTypeConfig<FormlySelectFieldProps<T>>
> {
  protected readonly Infinity = Infinity

  public onMouseOver(item: FormlySelectOption<T>): void {
    if (this.props.optionItemOverCallback) {
      this.props.optionItemOverCallback(this.field, item)
    }
  }
}
